import React, { useEffect, useState, useMemo } from 'react';
import BModal from 'react-bootstrap/Modal';
import { Link, useHistory } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useComparable from '~/commons/hooks/useComparable';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListPagination from '~/commons/components/ListPagination.jsx';
import ModalAnsConfirm from '../modals/ModalAnsConfirm.jsx';
import BtnLimit from '../btns/BtnLimit.jsx';
import BtnSort from '../btns/BtnSort.jsx';
import GridAssignments from './GridAssignments.jsx';
import ListAssignments from './ListAssignments.jsx';
import BorderBox from './BorderBox.jsx';
import GridMissions from './GridMissions.jsx';
import ReadingList from '../pages/ReadingList.jsx';
import MissionBar from './MissionBar.jsx';
import ReadingListItems from './ReadingListItems.jsx';
import env from '../../config/env.js';

const OpenedModalContent = ({ slot, onStart }) => (
    <div className="text-center p-4">
      <h4 className="open-modal-title">
        你已選擇打開{String(slot + 100).substring(1)}號寶箱文章
      </h4>
      <button onClick={onStart} className="m-2 btn btn-outline-orange-rounded">
        <img src="/assets/img/pen-icon.png" />
        開始任務
      </button>
    </div>
);

const StartMissionConfirmModalContent = ({ onConfirm, onReject }) => (
    <div className="text-center p-4">
      <h4 className="open-modal-title">確定開始任務？</h4>
      <h4 className="start-mission-text">
        你僅有一次作答機會！ 一旦開始， 將不能退出或中斷閱讀！
      </h4>
      <button
        onClick={onConfirm}
        className="m-2 btn btn-outline-orange-rounded"
      >
        確認
      </button>
      <button
        onClick={onReject}
        className="m-2 btn btn-outline-dark rounded rounded-pill btn-cancel"
      >
        取消
      </button>
    </div>
);

const ReadingMissions = ({
  assignments,
  assignmentId,
}) => {
  const [res, req, fetched = { total: 0 }] = useHttpStatus();
  const [, reqOpen] = useHttpStatus();
  const [modalContent, setModalContent] = useState(null);
  // const [assignmentRes, assignmentReq] = useHttpStatus();
  const history = useHistory();
  const currentMission = assignments.find((a) => a._id == assignmentId);
  const fetch = () => {
    req({
      url: `/api/quiz/assignments/missions/${assignmentId}`,
      params: {
        sort: { slot: 1 },
      },
    });
  };

  const doStart = (a) => {
    setModalContent(
      <StartMissionConfirmModalContent
        onConfirm={() => {
          history.push(`/app/mission/${a._id}`);
        }}
        onReject={() => setModalContent(null)}
      />,
    );
  };

  const doOpen = (a) => {
    reqOpen({
      method: 'patch',
      url: `/api/quiz/answers/${a._id}`,
      data: {
        status: 'opened',
      },
    })
      .then((res) => {
        fetch();
        doStart(a);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const onOpen = (a) => {
    console.log({ a: a.status });
    if (a.status == 'pending') {
      setModalContent(
        <OpenedModalContent
          slot={a.slot}
          onStart={() => {
            doOpen(a);
          }}
        />,
      );
    } else if (a.status == 'opened') {
      doStart(a);
    } else {
      history.push(`/app/mission/${a._id}`);
    }
  };

  useEffect(() => {
    fetch();
    // assignmentReq({
    //   url: `/api/quiz/assignments/${assignmentId}`,
    // });
  }, [assignmentId]);

  // const assignment = useMemo(() => {
  //   if (assignmentRes && assignmentRes.status === 'success') {
  //     return assignmentRes.payload;
  //   }
  //   return {};
  // }, [assignmentRes]);
  // const now = new Date();
  // const start = assignment && new Date(assignment.startDate);
  // const end = assignment && new Date(assignment.endDate);
  // // True if now is after the period (after endDate)
  // const isAfterPeriod = now > end;
  // // True if now is before the period (before startDate)
  // const isBeforePeriod = now < start;
  // // True if now is within the period (inclusive)
  // const isWithinPeriod = now >= start && now <= end;

  // if (isAfterPeriod) {
  //   return (
  //           <ReadingList assignmentId={assignmentId} />

  //   );
  // }
  return (
    <PageHttp res={res} className="position-relative">
      {(rows) => (
        <>
          <BModal
            centered
            show={modalContent != null}
            onHide={() => setModalContent(null)}
          >
            <div
              className="open-btn-close"
              onClick={() => setModalContent(null)}
            >
              <img src="/assets/img/close-orange.png" />
            </div>
            <BModal.Body>{modalContent}</BModal.Body>
          </BModal>
          <div className="container-fluid no-gutters px-0">
            <MissionBar
              assignments={assignments}
              current={assignmentId}
              onNavTo={(id) => history.push(`/app/missions/${id}`)}
            />
            <BorderBox
              name="missions-box"
              left={{
                width: '45px',
                background: 'linear-gradient(180deg, #B1EAFF 0%, #78DBFF 100%)',
              }}
              right={{
                width: '45px',
                background: 'linear-gradient(180deg, #15C1FF 0%, #A8E2F7 100%)',
              }}
              top={{ height: '53px' }}
              bottom={{ height: '53px' }}
            >
              {currentMission.closed ? (
              <ReadingListItems assigments={rows} />
              ) : (
              <div className="missions-book-shelf-frame">
                <BorderBox
                  name="missions-book-shelf"
                  style={{
                    background:
                      'linear-gradient(180deg, #C8E5FF 0%, #E8F5FF 100%)',
                  }}
                  left={{ width: '57px' }}
                  right={{ width: '57px' }}
                  top={{ height: '57px' }}
                  bottom={{ height: '57px' }}
                >
                  <div className="missions-book-self-inner-box">
                    <GridMissions rows={rows} onOpen={onOpen} />
                  </div>
                </BorderBox>
              </div>
              )}
            </BorderBox>
          </div>
        </>
      )}
    </PageHttp>
  );
};

export default ReadingMissions;
